<template>
    <span><i class="fa"
    v-bind:class="{'fa-shopping-cart': this.isValid, 'fa-exclamation-triangle': !this.isValid}"></i></span>
</template>

<script>
export default {

    data() {
        return {
            isValid: true
        }
    },

    created() {
        this.verifyCart();
        setInterval(this.verifyCart, 30 * 1000);
    },
    methods: {
        verifyCart() {
            new Form()
                .get('/api/cart/isValid')
                .then((response) => {
                    this.isValid = response.isValid;
                }).catch(errors => {
                this.isValid = false;
            });
        }
    }
}
</script>
